import React from 'react';
import { Helmet } from 'react-helmet-async';
import { getAllPublicRoutes } from '../seo/routeRegistry';

export default function PrerenderIndexPage() {
  const routes = getAllPublicRoutes();
  
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div style={{ padding: '20px' }}>
        <h1>Prerender Index</h1>
        <p>Esta página ayuda a react-snap a descubrir todas las rutas.</p>
        <ul>
          {routes.map((path) => (
            <li key={path}>
              <a href={path}>{path}</a>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
